import { useContext, useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faClock,
    faToggleOn,
    faToggleOff,
} from '@fortawesome/free-solid-svg-icons'
import Aside from '../../component/aside'
import Navbar from '../../component/navbar'
import RequestQueue from '../../api/requestQueue'
import { toast } from 'react-toastify'
import Loading from '../../component/loading'
import { useNavigate, useParams } from 'react-router-dom'
import { AppContextMenu } from '../../App'

const OrganizationWorkingHoursEdit = () => {
    const { updateValue } = useContext(AppContextMenu)
    useEffect(() => {
        updateValue('organization')
    }, [])
    const [loading, setLoading] = useState(false)
    const { id, name } = useParams()

    const [isCreate, setIsCreate] = useState(false)
    const [workingHours, setWorkingHours] = useState({
        saturday: {
            from: '08:00',
            to: '16:00',
            active: false,
            breakFrom: '13:00',
            breakTo: '14:00',
            hasBreak: false,
        },
        sunday: {
            from: '08:00',
            to: '16:00',
            active: false,
            breakFrom: '13:00',
            breakTo: '14:00',
            hasBreak: false,
        },
        monday: {
            from: '08:00',
            to: '16:00',
            active: false,
            breakFrom: '13:00',
            breakTo: '14:00',
            hasBreak: false,
        },
        tuesday: {
            from: '08:00',
            to: '16:00',
            active: false,
            breakFrom: '13:00',
            breakTo: '14:00',
            hasBreak: false,
        },
        wednesday: {
            from: '08:00',
            to: '16:00',
            active: false,
            breakFrom: '13:00',
            breakTo: '14:00',
            hasBreak: false,
        },
        thursday: {
            from: '08:00',
            to: '16:00',
            active: false,
            breakFrom: '13:00',
            breakTo: '14:00',
            hasBreak: false,
        },
        friday: {
            from: '08:00',
            to: '16:00',
            active: false,
            breakFrom: '13:00',
            breakTo: '14:00',
            hasBreak: false,
        },
    })
    let navigate = useNavigate()

    useEffect(() => {
        fetchWorkingHours()
    }, [])

    const fetchWorkingHours = async () => {
        setLoading(true)

        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/organization-working-hours/${id}`,
            },
            resolve: (res) => {
                if (!res.data) {
                    setIsCreate(true)
                } else {
                    const data = res.data

                    setWorkingHours({
                        saturday: {
                            from: data.saturdayFrom
                                ? data.saturdayFrom.slice(0, 5)
                                : '08:00',
                            to: data.saturdayTo
                                ? data.saturdayTo.slice(0, 5)
                                : '16:00',
                            active: data.saturdayFrom !== null,
                            breakFrom: data.saturdayBreakFrom
                                ? data.saturdayBreakFrom.slice(0, 5)
                                : '13:00',
                            breakTo: data.saturdayBreakTo
                                ? data.saturdayBreakTo.slice(0, 5)
                                : '14:00',
                            hasBreak: data.saturdayBreakFrom !== null,
                        },
                        sunday: {
                            from: data.sundayFrom
                                ? data.sundayFrom.slice(0, 5)
                                : '08:00',
                            to: data.sundayTo
                                ? data.sundayTo.slice(0, 5)
                                : '16:00',
                            active: data.sundayFrom !== null,
                            breakFrom: data.sundayBreakFrom
                                ? data.sundayBreakFrom.slice(0, 5)
                                : '13:00',
                            breakTo: data.sundayBreakTo
                                ? data.sundayBreakTo.slice(0, 5)
                                : '14:00',
                            hasBreak: data.sundayBreakFrom !== null,
                        },
                        monday: {
                            from: data.mondayFrom
                                ? data.mondayFrom.slice(0, 5)
                                : '08:00',
                            to: data.mondayTo
                                ? data.mondayTo.slice(0, 5)
                                : '16:00',
                            active: data.mondayFrom !== null,
                            breakFrom: data.mondayBreakFrom
                                ? data.mondayBreakFrom.slice(0, 5)
                                : '13:00',
                            breakTo: data.mondayBreakTo
                                ? data.mondayBreakTo.slice(0, 5)
                                : '14:00',
                            hasBreak: data.mondayBreakFrom !== null,
                        },
                        tuesday: {
                            from: data.tuesdayFrom
                                ? data.tuesdayFrom.slice(0, 5)
                                : '08:00',
                            to: data.tuesdayTo
                                ? data.tuesdayTo.slice(0, 5)
                                : '16:00',
                            active: data.tuesdayFrom !== null,
                            breakFrom: data.tuesdayBreakFrom
                                ? data.tuesdayBreakFrom.slice(0, 5)
                                : '13:00',
                            breakTo: data.tuesdayBreakTo
                                ? data.tuesdayBreakTo.slice(0, 5)
                                : '14:00',
                            hasBreak: data.tuesdayBreakFrom !== null,
                        },
                        wednesday: {
                            from: data.wednesdayFrom
                                ? data.wednesdayFrom.slice(0, 5)
                                : '08:00',
                            to: data.wednesdayTo
                                ? data.wednesdayTo.slice(0, 5)
                                : '16:00',
                            active: data.wednesdayFrom !== null,
                            breakFrom: data.wednesdayBreakFrom
                                ? data.wednesdayBreakFrom.slice(0, 5)
                                : '13:00',
                            breakTo: data.wednesdayBreakTo
                                ? data.wednesdayBreakTo.slice(0, 5)
                                : '14:00',
                            hasBreak: data.wednesdayBreakFrom !== null,
                        },
                        thursday: {
                            from: data.thursdayFrom
                                ? data.thursdayFrom.slice(0, 5)
                                : '08:00',
                            to: data.thursdayTo
                                ? data.thursdayTo.slice(0, 5)
                                : '16:00',
                            active: data.thursdayFrom !== null,
                            breakFrom: data.thursdayBreakFrom
                                ? data.thursdayBreakFrom.slice(0, 5)
                                : '13:00',
                            breakTo: data.thursdayBreakTo
                                ? data.thursdayBreakTo.slice(0, 5)
                                : '14:00',
                            hasBreak: data.thursdayBreakFrom !== null,
                        },
                        friday: {
                            from: data.fridayFrom
                                ? data.fridayFrom.slice(0, 5)
                                : '08:00',
                            to: data.fridayTo
                                ? data.fridayTo.slice(0, 5)
                                : '16:00',
                            active: data.fridayFrom !== null,
                            breakFrom: data.fridayBreakFrom
                                ? data.fridayBreakFrom.slice(0, 5)
                                : '13:00',
                            breakTo: data.fridayBreakTo
                                ? data.fridayBreakTo.slice(0, 5)
                                : '14:00',
                            hasBreak: data.fridayBreakFrom !== null,
                        },
                    })
                }

                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.error('خطا در دریافت ساعت‌کاری سازمان')
            },
        })
    }

    const handleTimeChange = (day, field, value) => {
        setWorkingHours((prev) => ({
            ...prev,
            [day]: {
                ...prev[day],
                [field]: value,
            },
        }))
    }

    const toggleDayActive = (day) => {
        setWorkingHours((prev) => ({
            ...prev,
            [day]: {
                ...prev[day],
                active: !prev[day].active,
                hasBreak: !prev[day].active ? prev[day].hasBreak : false,
            },
        }))
    }

    const toggleBreak = (day) => {
        setWorkingHours((prev) => ({
            ...prev,
            [day]: {
                ...prev[day],
                hasBreak: !prev[day].hasBreak,
            },
        }))
    }

    const handleSubmit = async () => {
        const payload = {
            saturdayFrom: workingHours.saturday.active
                ? `${workingHours.saturday.from}:00`
                : null,
            saturdayTo: workingHours.saturday.active
                ? `${workingHours.saturday.to}:00`
                : null,
            saturdayBreakFrom:
                workingHours.saturday.hasBreak && workingHours.saturday.active
                    ? `${workingHours.saturday.breakFrom}:00`
                    : null,
            saturdayBreakTo:
                workingHours.saturday.hasBreak && workingHours.saturday.active
                    ? `${workingHours.saturday.breakTo}:00`
                    : null,
            sundayFrom: workingHours.sunday.active
                ? `${workingHours.sunday.from}:00`
                : null,
            sundayTo: workingHours.sunday.active
                ? `${workingHours.sunday.to}:00`
                : null,
            sundayBreakFrom:
                workingHours.sunday.hasBreak && workingHours.sunday.active
                    ? `${workingHours.sunday.breakFrom}:00`
                    : null,
            sundayBreakTo:
                workingHours.sunday.hasBreak && workingHours.sunday.active
                    ? `${workingHours.sunday.breakTo}:00`
                    : null,
            mondayFrom: workingHours.monday.active
                ? `${workingHours.monday.from}:00`
                : null,
            mondayTo: workingHours.monday.active
                ? `${workingHours.monday.to}:00`
                : null,
            mondayBreakFrom:
                workingHours.monday.hasBreak && workingHours.monday.active
                    ? `${workingHours.monday.breakFrom}:00`
                    : null,
            mondayBreakTo:
                workingHours.monday.hasBreak && workingHours.monday.active
                    ? `${workingHours.monday.breakTo}:00`
                    : null,
            tuesdayFrom: workingHours.tuesday.active
                ? `${workingHours.tuesday.from}:00`
                : null,
            tuesdayTo: workingHours.tuesday.active
                ? `${workingHours.tuesday.to}:00`
                : null,
            tuesdayBreakFrom:
                workingHours.tuesday.hasBreak && workingHours.tuesday.active
                    ? `${workingHours.tuesday.breakFrom}:00`
                    : null,
            tuesdayBreakTo:
                workingHours.tuesday.hasBreak && workingHours.tuesday.active
                    ? `${workingHours.tuesday.breakTo}:00`
                    : null,
            wednesdayFrom: workingHours.wednesday.active
                ? `${workingHours.wednesday.from}:00`
                : null,
            wednesdayTo: workingHours.wednesday.active
                ? `${workingHours.wednesday.to}:00`
                : null,
            wednesdayBreakFrom:
                workingHours.wednesday.hasBreak && workingHours.wednesday.active
                    ? `${workingHours.wednesday.breakFrom}:00`
                    : null,
            wednesdayBreakTo:
                workingHours.wednesday.hasBreak && workingHours.wednesday.active
                    ? `${workingHours.wednesday.breakTo}:00`
                    : null,
            thursdayFrom: workingHours.thursday.active
                ? `${workingHours.thursday.from}:00`
                : null,
            thursdayTo: workingHours.thursday.active
                ? `${workingHours.thursday.to}:00`
                : null,
            thursdayBreakFrom:
                workingHours.thursday.hasBreak && workingHours.thursday.active
                    ? `${workingHours.thursday.breakFrom}:00`
                    : null,
            thursdayBreakTo:
                workingHours.thursday.hasBreak && workingHours.thursday.active
                    ? `${workingHours.thursday.breakTo}:00`
                    : null,
            fridayFrom: workingHours.friday.active
                ? `${workingHours.friday.from}:00`
                : null,
            fridayTo: workingHours.friday.active
                ? `${workingHours.friday.to}:00`
                : null,
            fridayBreakFrom:
                workingHours.friday.hasBreak && workingHours.friday.active
                    ? `${workingHours.friday.breakFrom}:00`
                    : null,
            fridayBreakTo:
                workingHours.friday.hasBreak && workingHours.friday.active
                    ? `${workingHours.friday.breakTo}:00`
                    : null,
        }

        setLoading(true)

        if (isCreate) {
            payload.shift_id = id
            await RequestQueue.sendRequest({
                config: {
                    method: 'post',
                    url: `/organization-working-hours`,
                    data: payload,
                },
                resolve: (res) => {
                    toast.success('ساعت‌کاری سازمان با موفقیت به‌روزرسانی شد')
                    navigate(-1)
                    setLoading(false)
                },
                reject: (error) => {
                    setLoading(false)
                    toast.error('خطا در به‌روزرسانی ساعت‌کاری')
                },
            })
        } else {
            await RequestQueue.sendRequest({
                config: {
                    method: 'patch',
                    url: `/organization-working-hours/${id}`,
                    data: payload,
                },
                resolve: (res) => {
                    toast.success('ساعت‌کاری سازمان با موفقیت به‌روزرسانی شد')
                    navigate(-1)
                    setLoading(false)
                },
                reject: (error) => {
                    setLoading(false)
                    toast.error('خطا در به‌روزرسانی ساعت‌کاری')
                },
            })
        }
    }

    const days = [
        { name: 'saturday', label: 'شنبه' },
        { name: 'sunday', label: 'یکشنبه' },
        { name: 'monday', label: 'دوشنبه' },
        { name: 'tuesday', label: 'سه‌شنبه' },
        { name: 'wednesday', label: 'چهارشنبه' },
        { name: 'thursday', label: 'پنجشنبه' },
        { name: 'friday', label: 'جمعه' },
    ]

    return (
        <>
            {loading && <Loading />}
            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />

                    <div className="bg-white rounded-xl shadow-lg  border border-gray-200 mx-4 my-6">
                        {/* Header */}
                        <div className="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-indigo-600 to-purple-600">
                            <h2 className="text-xl font-bold text-white">
                                ویرایش ساعت‌کاری شیفت {name}
                            </h2>
                        </div>

                        {/* Form Content */}
                        <div className="p-6">
                            <div className="space-y-4">
                                {days.map((day) => (
                                    <div
                                        key={day.name}
                                        className="flex flex-col md:flex-row items-center justify-between p-4 bg-gray-50 rounded-lg"
                                    >
                                        <div className="flex items-center mb-2 md:mb-0 w-full md:w-1/4">
                                            <button
                                                onClick={() =>
                                                    toggleDayActive(day.name)
                                                }
                                                className={`mr-3 ${workingHours[day.name].active ? 'text-green-600' : 'text-gray-400'}`}
                                            >
                                                <FontAwesomeIcon
                                                    icon={
                                                        workingHours[day.name]
                                                            .active
                                                            ? faToggleOn
                                                            : faToggleOff
                                                    }
                                                    size="lg"
                                                />
                                            </button>
                                            <span className="font-medium mr-2">
                                                {day.label}
                                            </span>
                                        </div>

                                        <div
                                            className={`flex-1 grid grid-cols-2 gap-4 w-full maxLg:flex-col maxLg:flex ${!workingHours[day.name].active && 'opacity-50'}`}
                                        >
                                            <div className="flex items-center">
                                                <FontAwesomeIcon
                                                    icon={faClock}
                                                    className="ml-2 text-gray-500"
                                                />
                                                <label className="ml-2">
                                                    از:
                                                </label>
                                                <input
                                                    type="time"
                                                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                    value={
                                                        workingHours[day.name]
                                                            .from
                                                    }
                                                    onChange={(e) =>
                                                        handleTimeChange(
                                                            day.name,
                                                            'from',
                                                            e.target.value
                                                        )
                                                    }
                                                    disabled={
                                                        !workingHours[day.name]
                                                            .active
                                                    }
                                                />
                                            </div>
                                            <div className="flex items-center">
                                                <FontAwesomeIcon
                                                    icon={faClock}
                                                    className="ml-2 text-gray-500"
                                                />
                                                <label className="ml-2">
                                                    تا:
                                                </label>
                                                <input
                                                    type="time"
                                                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                    value={
                                                        workingHours[day.name]
                                                            .to
                                                    }
                                                    onChange={(e) =>
                                                        handleTimeChange(
                                                            day.name,
                                                            'to',
                                                            e.target.value
                                                        )
                                                    }
                                                    disabled={
                                                        !workingHours[day.name]
                                                            .active
                                                    }
                                                />
                                            </div>
                                        </div>

                                        <div className="flex items-center mb-2 md:mb-0 w-full md:w-1/4">
                                            <button
                                                onClick={() =>
                                                    workingHours[day.name]
                                                        .active &&
                                                    toggleBreak(day.name)
                                                }
                                                className={`mr-3 ${workingHours[day.name].hasBreak ? 'text-green-600' : 'text-gray-400'}`}
                                            >
                                                <FontAwesomeIcon
                                                    icon={
                                                        workingHours[day.name]
                                                            .hasBreak
                                                            ? faToggleOn
                                                            : faToggleOff
                                                    }
                                                    size="lg"
                                                />
                                            </button>
                                            <span className="font-medium mr-2">
                                                استراحت {day.label}
                                            </span>
                                        </div>

                                        <div
                                            className={`flex-1 grid grid-cols-2 gap-4 w-full maxLg:flex-col maxLg:flex ${!workingHours[day.name].hasBreak && 'opacity-50'}`}
                                        >
                                            <div className="flex items-center">
                                                <FontAwesomeIcon
                                                    icon={faClock}
                                                    className="ml-2 text-gray-500"
                                                />
                                                <label className="ml-2">
                                                    از:
                                                </label>
                                                <input
                                                    type="time"
                                                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                    value={
                                                        workingHours[day.name]
                                                            .breakFrom
                                                    }
                                                    onChange={(e) =>
                                                        handleTimeChange(
                                                            day.name,
                                                            'breakFrom',
                                                            e.target.value
                                                        )
                                                    }
                                                    disabled={
                                                        !workingHours[day.name]
                                                            .hasBreak
                                                    }
                                                />
                                            </div>
                                            <div className="flex items-center">
                                                <FontAwesomeIcon
                                                    icon={faClock}
                                                    className="ml-2 text-gray-500"
                                                />
                                                <label className="ml-2">
                                                    تا:
                                                </label>
                                                <input
                                                    type="time"
                                                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                    value={
                                                        workingHours[day.name]
                                                            .breakTo
                                                    }
                                                    onChange={(e) =>
                                                        handleTimeChange(
                                                            day.name,
                                                            'breakTo',
                                                            e.target.value
                                                        )
                                                    }
                                                    disabled={
                                                        !workingHours[day.name]
                                                            .hasBreak
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Form Actions */}
                            <div className="flex justify-end space-x-3 maxLg:flex-col space-x-reverse mt-8">
                                <button
                                    onClick={() => window.history.back()}
                                    className="px-6 my-2 py-3 border border-gray-300 rounded-xl text-gray-700 bg-white hover:bg-gray-50 transition-colors flex items-center"
                                >
                                    انصراف
                                </button>
                                <button
                                    onClick={handleSubmit}
                                    className="px-6 my-2 py-3 rounded-xl text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all shadow-md hover:shadow-lg flex items-center"
                                >
                                    ذخیره تغییرات
                                </button>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default OrganizationWorkingHoursEdit
